/**
 * Teilen-Button auf der Produktseite.
 * Nutzt das native Teilen-Menü (Mobil), sonst Kopieren in die Zwischenablage.
 * Ohne beides bleibt der Link im Prompt sichtbar – der Button funktioniert also
 * überall, nur unterschiedlich komfortabel.
 */
(function () {
  'use strict';

  if (customElements.get('product-share')) return;

  customElements.define(
    'product-share',
    class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('button');
        this.labelEl = this.querySelector('[data-share-label]');
        if (!this.btn) return;
        this.defaultLabel = this.labelEl ? this.labelEl.textContent : '';
        this.btn.addEventListener('click', this.onClick.bind(this));
      }

      get shareUrl() {
        var path = this.dataset.url || window.location.pathname;
        return window.location.origin + path;
      }

      onClick(e) {
        e.preventDefault();
        var data = { title: this.dataset.title || document.title, url: this.shareUrl };

        if (navigator.share) {
          navigator.share(data).catch(function () {
            /* Abbruch durch den Nutzer ist kein Fehler */
          });
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(this.shareUrl).then(
            this.flash.bind(this, 'Link kopiert'),
            this.fallback.bind(this)
          );
          return;
        }

        this.fallback();
      }

      fallback() {
        window.prompt('Link zum Teilen:', this.shareUrl);
      }

      flash(text) {
        if (!this.labelEl) return;
        this.labelEl.textContent = text;
        clearTimeout(this._t);
        this._t = setTimeout(
          function () {
            this.labelEl.textContent = this.defaultLabel;
          }.bind(this),
          2500
        );
      }
    }
  );
})();
